import { Button, Grid2 } from "@mui/material";
import { GoogleMap, useJsApiLoader, DirectionsRenderer, Polygon, DrawingManager } from '@react-google-maps/api';
import React, { useEffect, useRef, useState } from "react";
import DrawIcon from '@mui/icons-material/Draw';
import DeleteIcon from '@mui/icons-material/Delete';

const CommonGeofence = (props) => {
    const geofence = props.geofence ?? null;
    const onUpdatePolygon = props.onUpdatePolygon;

    const [mainGeofence, setMainGeofence] = useState([]);
    const [isPolygonVisible, setIsPolygonVisible] = useState(true);
    const [drawingMode, setDrawingMode] = useState(false);
    const [polygonPath, setPolygonPath] = useState([]);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const mapRef = useRef(null);

    const drawingManagerRef = useRef(null);
    // const { isLoaded } = useJsApiLoader({
    //     id: 'google-map-script',
    //     googleMapsApiKey: 'YOUR_GOOGLE_MAPS_API_KEY',
    //     libraries: ['drawing'],
    // });

    const containerStyle = { width: '100%', height: '460px' };

    useEffect(() => {
        if (geofence) {
            setMainGeofence(geofence);
        }
    }, [geofence]);

    useEffect(() => {
        if (mainGeofence && mainGeofence.length > 0 && mapLoaded && window.google) {
            const bounds = new window.google.maps.LatLngBounds();
            mainGeofence.forEach((point) => {
                bounds.extend({ lat: Number(point.x), lng: Number(point.y) });
            });
            mapRef.current.fitBounds(bounds);
        }
    }, [mainGeofence, mapLoaded]);

    const onLoad = React.useCallback((map) => {
        mapRef.current = map;
        setMapLoaded(true);
    }, []);

    const handlePolygonClick = () => {
        setSelectedPolygon(selectedPolygon ? null : mainGeofence);
    };

    // const handleDrawPolygon = () => {
    //     setDrawingMode(true);
    //     if (drawingManagerRef.current) {
    //         drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
    //     }
    // };

    // const handleUpdatePolygon = () => {
    //     if (onUpdatePolygon && polygonPath) {
    //         onUpdatePolygon(polygonPath);
    //     }
    // };

    const handleDeletePolygon = () => {
        // Delete the selected polygon
        setIsPolygonVisible(false);
        setSelectedPolygon(null);  // Reset the selection
    };
        
    const onLoadDrawingManager = (drawingManager) => {
        drawingManagerRef.current = drawingManager;
    };

    const onPolygonComplete = (polygon) => {
        const path = polygon.getPath().getArray();
        const coordinates = path.map(latLng => ({
            lat: latLng.lat(),
            lng: latLng.lng(),
        }));
        setPolygonPath(coordinates);
        setDrawingMode(false);  // Disable drawing mode after polygon is drawn
        // console.log('path = ', coordinates);
    };

    const handleDrawPolygon = () => {
        // if (!isLoaded || !window.google) {
        //     console.error("Google Maps API not loaded yet");
        //     return;
        // }
        setDrawingMode(true);
        if (drawingManagerRef.current) {
            drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
        }
    };
    const handleUpdatePolygon = () => {
        if (onUpdatePolygon && polygonPath) {
            console.log(['inside updaet'])
            onUpdatePolygon(polygonPath); // Call the parent function with selected polygon
        }
    };
        

    return (
        <Grid2>
            <Grid2 item container spacing={2}>
                <Grid2 item>
                    {selectedPolygon && (
                        <Button
                            variant="contained"
                            color="danger"
                            onClick={handleDeletePolygon}
                            style={{ marginTop: '5px' }}
                        >
                            <DeleteIcon/>
                        </Button>
                    )}
                </Grid2>

                <Grid2 item>
                    {/* {selectedPolygon && ( */}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleDrawPolygon}
                            style={{ marginTop: '5px' }}
                        >
                            <DrawIcon/>
                        </Button>
                    {/* )} */}
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleUpdatePolygon}
                        style={{ marginTop: '5px' }}
                    >
                        Update
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={{ lat: 28.644800, lng: 77.216721 }}
                    zoom={8}
                    onLoad={onLoad}
                >
                    {drawingMode && (
                        <DrawingManager
                            onLoad={(drawingManager) => (drawingManagerRef.current = drawingManager)}
                            onPolygonComplete={(polygon) => {
                                const path = polygon.getPath().getArray();
                                const coordinates = path.map((latLng) => ({
                                    lat: latLng.lat(),
                                    lng: latLng.lng(),
                                }));
                                setPolygonPath(coordinates);
                                setDrawingMode(false);
                            }}
                            drawingMode={window.google.maps.drawing.OverlayType.POLYGON}
                        />
                    )}
                    {mapLoaded && isPolygonVisible && mainGeofence && mainGeofence.length > 0 && (
                        <Polygon
                            paths={mainGeofence.map((point) => ({
                                lat: Number(point.x),
                                lng: Number(point.y),
                            }))}
                            options={{
                                fillColor: "rgba(255, 0, 0, 0.3)",
                                fillOpacity: 0.4,
                                strokeColor: "red",
                                strokeOpacity: 1,
                                strokeWeight: 2,
                            }}
                            onClick={handlePolygonClick}
                        />
                    )}
                </GoogleMap>
            </Grid2>
        </Grid2>
    );
};

export default CommonGeofence;
